module.exports = global["jQuery"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = ./node_modules/expose-loader/index.js?jQuery!./node_modules/jquery/dist/jquery.js
// module chunks = vendor